<template>
  <div
    v-if="showLoadingState < 1"
    key="loadingState"
    class="m-initial-loading"
  >
    <AtomLoadingPrimary/>
  </div>
  <div
    v-else
    class="m-card-primary m-the-modal-content"
  >
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="$modal.closeModal"
    >
      <header class="m-the-modal-header">
        <h5 v-if="$modal.element.changePlan">
          {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.header.changePlan') }}
        </h5>
        <h5 v-else-if="$modal.element.suscripcion.id_plan !== $modal.element.venta.id_plan">
          {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.header.changePaymentFrequency') }}
        </h5>
        <h5 v-else>
          {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.header.changePaymentMethod') }}
        </h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section
        v-if="$modal.element.changePlan"
        class="m-the-modal-section-height-auto m-edition-billing-my-payments-modal-pending-change-plan"
      >
        <p class="font-weight-bold text-color-danger margin-top-xsmall">
          {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.warningParagraph') }}
        </p>
        <p v-if="producto">
          <h4 class="font-weight-bold">
            {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.name') }}
            {{ producto.nombre }}
          </h4>
          <p v-if="producto.maximo_alumnos">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.student') }}
              <span class="font-size-xsmall text-color-black-45"> ({{ academyResourcesLicencia.alumnos }} en uso)</span>
            </span>
            <span class="info-text-right">
              {{ producto.maximo_alumnos }}
            </span>
          </p>
          <p v-if="producto.maximo_administradores">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.student') }}
              <span class="font-size-xsmall text-color-black-45"> ({{ academyResourcesLicencia.administradores }} en uso)</span>
            </span>
            <span class="info-text-right">
              {{ producto.maximo_administradores }}
            </span>
          </p>
          <p v-if="producto.maximo_administradores">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.admins') }}
              <span class="font-size-xsmall text-color-black-45"> ({{ academyResourcesLicencia.administradores }} en uso)</span>
            </span>
            <span class="info-text-right">
              {{ producto.maximo_administradores }}
            </span>
          </p>
          <p v-if="producto.maximo_profesores">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.teachers') }}
              <span class="font-size-xsmall text-color-black-45"> ({{ academyResourcesLicencia.profesores }} en uso)</span>
            </span>
            <span class="info-text-right">
              {{ producto.maximo_profesores }}
            </span>
          </p>
          <p v-if="producto.maximo_instructores">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.instructors') }}
              <span class="font-size-xsmall text-color-black-45"> ({{ academyResourcesLicencia.instructores }} en uso)</span>
            </span>
            <span class="info-text-right">
              {{ producto.maximo_instructores }}
            </span>
          </p>
          <p>
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.projects') }}
              <span class="font-size-xsmall text-color-black-45"> {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.unlimited') }} </span>
            </span>
            <span class="info-text-right"><i class="far fa-infinity"></i></span>
          </p>
          <p>
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.products') }}
              <span class="font-size-xsmall text-color-black-45"> {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.unlimited') }} </span>
            </span>
            <span class="info-text-right"><i class="far fa-infinity"></i></span>
          </p>
          <p>
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.maps') }}
              <span class="font-size-xsmall text-color-black-45"> {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.unlimited') }} </span>
            </span>
            <span class="info-text-right"><i class="far fa-infinity"></i></span>
          </p>
          <p>
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.salesData') }}
              <span class="font-size-xsmall text-color-black-45"> {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.unlimited') }} </span>
            </span>
            <span class="info-text-right"><i class="far fa-infinity"></i></span>
          </p>
          <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.mails') }}
              <span class="font-size-xsmall text-color-black-45"> ({{ producto.maximo_emails }})</span>
            </span>
          </p>
          <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.commissions.line1') }}
            </span>
            <span class="info-text-right">
              {{ producto.comisiones }}%
            </span>
          </p>
          <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.commissions.line2') }}
            </span>
            <span class="info-icon-right info-icon-billing">
              <i class="fas fa-check"></i>
            </span>
          </p>
          <p>
            <span class="info-text-left">
               {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.academy') }}
            </span>
            <span
              v-if="producto.tipo_universidad"
              class="info-icon-right info-icon-billing"
            >
              <i class="fas fa-check"></i>
            </span>
            <span
              v-else
              class="info-text-right text-color-black-35"
            >
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.not') }}
            </span>
          </p>
          <p>
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.integrations') }}
            </span>
            <span
              v-if="producto.integraciones"
              class="info-icon-right info-icon-billing"
            >
              <i class="fas fa-check"></i>
            </span>
            <span
              v-else
              class="info-text-right text-color-black-35"
            >
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.not') }}
            </span>
          </p>
          <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.liveClasses') }}
            </span>
            <span
              v-if="producto.clases_vivo"
              class="info-icon-right info-icon-billing"
            >
              <i class="fas fa-check"></i>
            </span>
            <span
              v-else
              class="info-text-right text-color-black-35"
            >
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.not') }}
            </span>
          </p>
          <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.affiliations') }}
            </span>
            <span
              v-if="producto.afiliaciones"
              class="info-icon-right info-icon-billing"
            >
              <i class="fas fa-check"></i>
            </span>
            <span
              v-else
              class="info-text-right text-color-black-35"
            >
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.not') }}
            </span>
          </p>
          <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.evaluations') }}
            </span>
            <span
              v-if="producto.evaluaciones"
              class="info-icon-right info-icon-billing"
            >
              <i class="fas fa-check"></i>
            </span>
            <span
              v-else
              class="info-text-right text-color-black-35"
            >
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.not') }}
            </span>
          </p>
          <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.studentControl') }}
            </span>
            <span
              v-if="producto.control_alumnos"
              class="info-icon-right info-icon-billing"
            >
              <i class="fas fa-check"></i>
            </span>
            <span
              v-else
              class="info-text-right text-color-black-35"
            >
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.not') }}
            </span>
          </p>
          <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.studentImport') }}
            </span>
            <span
              v-if="producto.importacion_alumnos"
              class="info-icon-right info-icon-billing"
            >
              <i class="fas fa-check"></i>
            </span>
            <span
              v-else
              class="info-text-right text-color-black-35"
            >
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.product.not') }}
            </span>
          </p>
        </p>
        <p class="margin-top-medium margin-bottom-zero"></p>
        <h4 class="font-weight-bold">
          {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.title') }}
        </h4>
        <div
          v-if="$modal.element.suscripcion"
          class="margin-bottom-medium"
        >
          <p>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-history"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.state.line1') }}
              <span :class="`font-weight-bold ${$filters.getSubscriptionStateValue($modal.element.suscripcion.estado, 'class')}`">
                {{ $filters.getSubscriptionStateValue($modal.element.suscripcion.estado, 'name') }}
              </span>
              <span v-if="$modal.element.suscripcion.estado_fecha">
                {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.state.line2') }}
                {{ $moment.parseZone($modal.element.suscripcion.estado_fecha).format('D MMMM, YYYY') }}
              </span>
            </span>
          </p>
          <p v-if="$modal.element.venta.trial_precio">
            <span class="info-icon-left info-icon-billing">
              <i class="far fa-clock"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.payTrial.line1') }}
              <span class="font-weight-bold">
                {{ $modal.element.venta.divisa }}
                {{ $modal.element.venta.trial_precio.toFixed(2) }}
              </span>
              <span class="text-color-black-35">
                {{ $modal.element.venta.divisa_iso_code }}
              </span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.payTrial.line2') }}
              {{ $modal.element.venta.medio_pago }}
            </span>
          </p>
          <p v-if="$modal.element.venta.trial_intervalo">
            <span class="info-icon-left info-icon-billing">
              <i class="far fa-clock"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.trial') }}
              <span class="font-weight-bold">
                {{ $modal.element.venta.trial_intervalo }}
                {{ $filters.getFrequencyValue($modal.element.venta.trial_frecuencia, 'name') }}
              </span>
            </span>
          </p>
          <p v-if="$modal.element.suscripcion.fecha_inicio && $moment.parseZone().isBefore($moment.parseZone($modal.element.suscripcion.fecha_inicio))">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-calendar-day"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.payFirst') }}
              <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
                {{ $moment.parseZone($modal.element.suscripcion.fecha_inicio).format('D MMMM, YYYY') }}
              </span>
            </span>
          </p>
          <p v-if="$modal.element.suscripcion.precio">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-money-bill"></i>
            </span>
            <span>
            {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.plan.line1') }}
            <span class="font-weight-bold">
              {{ $utils.getPaymentFrequency($modal.element.suscripcion.pago_cuotas, $modal.element.suscripcion.pago_frecuencia, $modal.element.suscripcion.pago_intervalo) }}
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.plan.line2') }}
              {{ $modal.element.suscripcion.divisa }}
              {{ $modal.element.suscripcion.precio.toFixed(2) }}
            </span>
              <span class="text-color-black-35">
                {{ $modal.element.suscripcion.divisa_iso_code }}
              </span>
          </span>
          </p>
          <p v-if="$modal.element.suscripcion.medio_pago">
            <span class="info-icon-left info-icon-billing">
              <i class="far fa-credit-card"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.payMethod') }}
              <span class="font-weight-bold">
                {{ $modal.element.suscripcion.medio_pago }}
              </span>
            </span>
          </p>
          <p v-if="$modal.element.suscripcion.id_externo">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-key"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.idExtern') }}
              <span class="font-weight-bold">
                {{ $modal.element.suscripcion.medio_pago }}
              </span>
              <i class="text-color-black-65">
                {{ $modal.element.suscripcion.id_externo }}
              </i>
            </span>
          </p>
          <p v-if="$modal.element.suscripcion.fecha_proximo_pago">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-calendar-day"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.payNext') }}
              <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
                {{ $moment.parseZone($modal.element.suscripcion.fecha_inicio).format('D MMMM, YYYY') }}
              </span>
            </span>
          </p>
          <p v-if="($modal.element.venta.cupon_codigo)">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-percentage"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.cupon.line1') }}
              <span class="font-weight-bold">
                {{ $modal.element.venta.cupon_codigo }}
              </span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.cupon.line2') }}
              <span class="font-weight-bold">
               {{ $modal.element.venta.cupon_monto }}%
              </span>
            </span>
          </p>
        </div>
      </section>
      <section
        v-else
        class="m-the-modal-section-height-auto m-edition-billing-my-payments-modal-pending-change-plan"
      >
        <p class="font-weight-bold text-color-danger margin-top-xsmall">
          {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.warningParagraph') }}
        </p>
        <div
          v-if="$modal.element.suscripcion"
          class="margin-bottom-medium"
        >
          <p>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-history"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.state.line1') }}
              <span :class="`font-weight-bold ${$filters.getSubscriptionStateValue($modal.element.suscripcion.estado, 'class')}`">
                {{ $filters.getSubscriptionStateValue($modal.element.suscripcion.estado, 'name') }}
              </span>
              <span v-if="$modal.element.suscripcion.estado_fecha">
                {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.state.line2') }}
                {{ $moment.parseZone($modal.element.suscripcion.estado_fecha).format('D MMMM, YYYY') }}
              </span>
            </span>
          </p>
          <p v-if="$modal.element.suscripcion.fecha_inicio && $moment.parseZone().isBefore($moment.parseZone($modal.element.suscripcion.fecha_inicio))">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-calendar-day"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.payFirst') }}
              <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
                {{ $moment.parseZone($modal.element.suscripcion.fecha_inicio).format('D MMMM, YYYY') }}
              </span>
            </span>
          </p>
          <p v-if="$modal.element.suscripcion.precio">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-money-bill"></i>
            </span>
            <span>
            {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.plan.line1') }}
            <span class="font-weight-bold">
             {{ $utils.getPaymentFrequency($modal.element.suscripcion.pago_cuotas, $modal.element.suscripcion.pago_frecuencia, $modal.element.suscripcion.pago_intervalo) }}
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.plan.line2') }}
             {{ $modal.element.suscripcion.divisa }}
             {{ $modal.element.suscripcion.precio.toFixed(2) }}
            </span>
              <span class="text-color-black-35">
                {{ $modal.element.suscripcion.divisa_iso_code }}
              </span>
          </span>
          </p>
          <p v-if="$modal.element.suscripcion.medio_pago">
            <span class="info-icon-left info-icon-billing">
              <i class="far fa-credit-card"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.payMethod') }}
              <span class="font-weight-bold">
                {{ $modal.element.suscripcion.medio_pago }}
              </span>
            </span>
          </p>
          <p v-if="$modal.element.suscripcion.id_externo">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-key"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.idExtern') }}
              <span class="font-weight-bold">
                {{ $modal.element.suscripcion.medio_pago }}
              </span>
              <i class="text-color-black-65">
                {{ $modal.element.suscripcion.id_externo }}
              </i>
            </span>
          </p>
          <p v-if="$modal.element.suscripcion.fecha_proximo_pago">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-calendar-day"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.payNext') }}
              <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
                {{ $moment.parseZone($modal.element.suscripcion.fecha_inicio).format('D MMMM, YYYY') }}
              </span>
            </span>
          </p>
          <p v-if="($modal.element.suscripcion.cupon_codigo && $modal.element.suscripcion.id_plan !== $modal.element.venta.id_plan)">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-percentage"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.cupon.line1') }}
              {{ $modal.element.suscripcion.cupon_codigo }}
              {{ $t('mEditionBillingMyPaymentsModalPendingChangePlan.section.subscription.cupon.line2') }}
              {{ $modal.element.suscripcion.cupon_monto }}%</span>
          </p>
        </div>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyPaymentsModalPendingChangePlan',

  data () {
    return {
      buttonPrimary: {
        action: 'Entendido',
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      },
      producto: null,
      showLoadingState: 0
    }
  },

  computed: {
    academyResourcesLicencia () {
      return this.$store.getters.getAcademyResources
    },

    trial () {
      return this.$modal.element.venta.trial_intervalo &&
        this.$modal.element.suscripcion &&
        this.$modal.element.suscripcion.fecha_inicio &&
        this.$moment.parseZone().isBefore(this.$moment.parseZone(this.$modal.element.suscripcion.fecha_inicio))
    }
  },

  created () {
    this.$modal.element.changePlan
      ? this.readProducto()
      : this.showLoadingState++
  },

  methods: {
    readProducto () {
      this.$services.read('producto', 'readProducto', {}, [this.$modal.element.venta.producto_venta])
        .then(response => {
          this.producto = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
